<template>
	<div class="ts-space-y-3 ts-overflow-scroll ts-p-2" style="height: 60vh">
		<div
			v-for="(invoice, index) in model.stock_out_id_list"
			:key="index"
		>
		<div class="ts-flex ts-justify-between">
			<p class="ts-border ts-border-blue-600 ts-px-2 ts-py-1 ts-mb-0 ts-text-red-500 ts-font-semibold ts-rounded" style="width:fit-content">
				{{ invoice.invoice_no }}
			</p>
			<a 
				href="#" 
				class="ts-text-red-700"
				@click.prevent="remove(index)"
			><i class="fas fa-times"></i></a>
		</div>
		<table class="ts-w-full ts-mt-3">
			<thead>
				<tr>
					<th class="ts-bg-gray-200 ts-uppercase ts-py-1 ts-px-3 ts-border-l ts-border-r ts-border-blue-600 ts-w-8">No</th>
					<th class="ts-bg-gray-200 ts-uppercase ts-py-1 ts-px-3 ts-border-r ts-border-blue-600">Product</th>
					<th class="ts-bg-gray-200 ts-uppercase ts-py-1 ts-px-3 ts-border-r ts-border-blue-600 ts-w-24">UOM</th>
					<th class="ts-bg-gray-200 ts-uppercase ts-py-1 ts-px-3 ts-border-r ts-border-blue-600 ts-w-24 ts-whitespace-no-wrap">Qty Invoice</th>
					<th class="ts-bg-gray-200 ts-uppercase ts-py-1 ts-px-3 ts-border-r ts-border-blue-600 ts-w-24 ts-whitespace-no-wrap">Qty Deliver</th>
					<th class="ts-bg-gray-200 ts-uppercase ts-py-1 ts-px-3 ts-border-r ts-border-blue-600 ts-w-24 ts-whitespace-no-wrap">Type</th>
				</tr>
			</thead>
			<tbody>
				<tr
					class="ts-border-b"
					v-for="(item, itemIndex) in invoice.details"
					:key="itemIndex"
				>
					<td class="ts-py-1 ts-px-3 ts-text-center">{{ itemIndex + 1 }}</td>
					<td class="ts-py-1 ts-px-3">{{ item.product_name_en }}</td>
					<td class="ts-py-1 ts-px-3">{{ item.uom_name_en }}</td>
					<td class="ts-py-1 ts-px-3 ts-text-right">{{ item.quantity }}</td>
					<td class="ts-py-1 ts-px-3 ts-text-right">
						<input 
							type="number" 
							v-model.number="item.qty_delivered"
							class="ts-p-2 ts-border ts-border-gray-300 ts-rounded ts-outline-none ts-text-right"
						>
					</td>
					<td class="ts-py-1 ts-px-3 ts-text-left">
							{{ stockOuttype(item.stock_out_type_id) }}
					</td>
				</tr>
			</tbody>
		</table>
		<hr class="ts-bg-blue-500">
		</div>
	</div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
	name: 'invoiceDetail',
	props: ['value', 'validate'],
	data(){
		return {
			errors: new Errors(),
			model: {}
		}
	},
	computed: {
		stockOuttype: vm => stockoutTypeId => {
			switch(stockoutTypeId){
				case 1:
					return 'Normal'
				case 2:
					return 'Ring Pull'
				default :
					return 'N/A'
			}
		}
	},
	created(){
		this.model = this.value
	},
	methods: {
		remove(index) {
			this.model.stock_out_id_list.splice(index, 1)
		}
	},
	watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>